module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aries/ari_dn-8c48699a60cddd6a11796904abb2615b.gif";